let config: AppConfig | null = null

export async function loadConfig(): Promise<AppConfig> {
  if (!config) {
    const response = await fetch('/config.json')
    const data: any = await response.json()

    // Validate config structure
    if (
      !data ||
      !data.apiUrl ||
      !data.msalTenantId ||
      !data.msalClientId ||
      !data.msalScope
    ) {
      throw new Error('Invalid config structure')
    }

    // Convert feature strings to booleans
    if ('features' in data) {
      for (const [key, value] of Object.entries(data.features)) {
        if (typeof value === 'string') {
          switch (value) {
            case 'true':
              data.features[key] = true
              break
            case 'false':
              data.features[key] = false
              break
            default:
              break
          }
        }
      }
    }

    config = data as AppConfig
  }

  return config
}

function getConfig(): AppConfig {
  if (!config) {
    throw new Error('Config not loaded. Call loadConfig() first.');
  }
  return config;
}

export default {
  get version(): string {
    return getConfig().version ?? "0.0.0";
  },
  get build(): string {
    return import.meta.env.VITE_BUILD ?? "0";
  },
  get environment(): string {
    return getConfig().environment ?? "development";
  },
  get apiUrl(): string {
    return getConfig().apiUrl;
  },
  get msalTenantId(): string {
    return getConfig().msalTenantId;
  },
  get msalClientId(): string {
    return getConfig().msalClientId;
  },
  get msalScope(): string {
    return getConfig().msalScope;
  },
  get features(): Features {
    const features = getConfig().features

    // If no features are defined in config, set a default
    if (!features || typeof features !== 'object') {
      return {
        insights: true,
        invoicing: true,
        contracts: 'manual'
      }
    }

    return features
  },
  get globalStateRefreshIntervalInSeconds(): number {
    const value = getConfig().globalStateRefreshIntervalInSeconds
    return value ? parseInt(value) : 30
  },
  get sentry(): SentryConfig {
    const config = getConfig()

    return {
      enabled: typeof config.sentry?.enabled === 'string' && config.sentry.enabled === 'true'
    }
  }
};